import React, { useState } from "react";
import "./refund-policy.scss";
import WhiteArrow from "../../../assets/Icons/WhiteArrow";

const RefundPolicy = () => {
  // collapsed by default
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className="refund-policy-section">
      <div className="refund-policy-wrapper">
        
        {/* ✅ Header - now consistent */}
        <div className="refund-header">
          <h4 className="refund-heading">Refund Policy</h4>

          <button
            className={`toggle-btn ${isOpen ? "open" : "closed"}`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <WhiteArrow />
          </button>
        </div>

        {/* ✅ Body */}
        {isOpen && (
          <div className="refund-body">
            <p className="refund-subtext">
              ✨ <strong>Teleport Now eSIM Refund Policy</strong> ✨
            </p>

            <p>We’ve got your back, traveler! You're eligible for a refund when:</p>

            <ul>
              <li>You send in a request within <strong>30 days</strong> of the issue.</li>
              <li>You work with our support team so we can attempt to fix the issue.</li>
              <li>
                Your eSIM <strong>was activated but could not be used</strong> due to a Teleport Now error or
                because the service was retired.
              </li>
            </ul>

            <p>In these cases, we’ll either:</p>

            <ul>
              <li>✅ Give you a replacement service, OR</li>
              <li>✅ Refund your full purchase.</li>
            </ul>

            <hr />

            <h5>💡 Changed your mind?</h5>
            <p>
              If your eSIM hasn’t been <strong>installed</strong> or <strong>activated</strong>, we will refund
              you (via <strong>Telly Credits</strong> or your original payment method).
            </p>

            <hr />

            <h5>A few more things to note:</h5>
            <ul>
              <li>If we cannot restore your access within <strong>10 days</strong>, you're eligible for a refund.</li>
              <li>
                Contact us at:
                <br />
                ✉️ <a href="mailto:support@teleportapp.sg">support@teleportapp.sg</a><br />
                💬 In-app chat / web chat
              </li>
              <li>We may request screenshots or device settings to confirm the issue.</li>
              <li>
                Refunds take up to <strong>30 business days</strong> depending on the payment provider.
              </li>
            </ul>
          </div>
        )}
      </div>
    </section>
  );
};

export default RefundPolicy;
